import React from "react";
import PropTypes from "prop-types";
import { cloudinaryImageAdapter } from "../../sharedComponents/CloudinaryImageAdapter";
import { Testimonial } from "./Testimonial";

const TestimonialConnector = ({ data }) => (
	<Testimonial
		displayTitle={data.displayTitle}
		quote={data.quote.childMarkdownRemark.html}
		source={data.source}
		date={data.date}
		image={
			data?.image && {
				...cloudinaryImageAdapter({
					cloudinaryImage: data?.image?.[0],
					title: data?.displayTitle,
					desc: data?.displayTitle,
					adoptHeight: true,
					maxWidth: "400",
					aspectRatio: 1.77,
				}),
			}
		}
		branding={data.branding}
	/>
);

TestimonialConnector.propTypes = {
	data: PropTypes.shape({
		displayTitle: PropTypes.string,
		quote: PropTypes.shape({
			childMarkdownRemark: PropTypes.shape({
				html: PropTypes.string,
			}),
		}),
		source: PropTypes.string,
		date: PropTypes.string,
		branding: PropTypes.string,
		image: PropTypes.arrayOf(
			PropTypes.shape({
				secure_url: PropTypes.string,
				width: PropTypes.string,
				height: PropTypes.string,
				raw_transformation: PropTypes.string,
				version: PropTypes.string,
				public_id: PropTypes.string,
				format: PropTypes.string,
			})
		),
	}),
};
TestimonialConnector.defaultProps = {
	data: undefined,
};

export default TestimonialConnector;
export { TestimonialConnector };
